// extracted by mini-css-extract-plugin
export default {"position":"CurtainModal_position__tO7jm"};